import { Mapper } from 'modules/cm/mapper/types';
import { AffordabilityResults } from 'modules/cm/domain/Case/LoanDetails';
import { AffordabilityResults as APIAffordabilityResults } from 'modules/cm/api/cases/types';
import { FIELDS } from 'modules/cm/fields/types';
import { fromDomainToApiMapper } from 'modules/cm/mapper/mappings';

const mapper: Mapper<APIAffordabilityResults, AffordabilityResults> = {
  mapApiToDomain: (api) => {
    return {
      [FIELDS.AFT_STAGE]: api.afStage,
      [FIELDS.AFT_INCOME]: api.afDisposableIncome ? Number(api.afDisposableIncome) : null,
      [FIELDS.AFT_BUFFER]: api.afDisposableIncomeBuffer ? Number(api.afDisposableIncomeBuffer) : null,
      [FIELDS.AFT_LIVING_COSTS]: api.afLivingCosts ? Number(api.afLivingCosts) : null,
      [FIELDS.AFT_NET_CASH_FLOW]: api.afNetCashflow ? Number(api.afNetCashflow) : null,
      [FIELDS.AFT_MAX_LOAN_POSSIBLE]: api.afMaxLoanPossible ? Number(api.afMaxLoanPossible) : null,
    };
  },
  mapDomainFieldToAPI: (field: string, value: any): any => {
    const { mapNumber } = fromDomainToApiMapper;
    const map = new Map<keyof AffordabilityResults, (value: any) => any>([
      [FIELDS.AFT_BUFFER, mapNumber],
      [FIELDS.AFT_INCOME, mapNumber],
      [FIELDS.AFT_LIVING_COSTS, mapNumber],
      [FIELDS.AFT_NET_CASH_FLOW, mapNumber],
      [FIELDS.AFT_MAX_LOAN_POSSIBLE, mapNumber],
    ]);
    const mapper = map.get(field as keyof AffordabilityResults);

    return mapper ? mapper(value) : value;
  },
  mapDomainNameToAPI: (field: string): string => {
    const map = new Map<keyof AffordabilityResults, keyof APIAffordabilityResults>([
      [FIELDS.AFT_STAGE, 'afStage'],
      [FIELDS.AFT_INCOME, 'afDisposableIncome'],
      [FIELDS.AFT_BUFFER, 'afDisposableIncomeBuffer'],
      [FIELDS.AFT_LIVING_COSTS, 'afLivingCosts'],
      [FIELDS.AFT_NET_CASH_FLOW, 'afNetCashflow'],
      [FIELDS.AFT_MAX_LOAN_POSSIBLE, 'afMaxLoanPossible'],
    ]);

    const name = map.get(field as keyof AffordabilityResults);

    return name || field;
  },
};

export const mapAffordabilityResultsToApi = (domain: AffordabilityResults): any => {
  const { mapNumber } = fromDomainToApiMapper;

  return {
    afStage: domain[FIELDS.AFT_STAGE],
    afDisposableIncome: mapNumber(domain[FIELDS.AFT_INCOME]),
    afDisposableIncomeBuffer: mapNumber(domain[FIELDS.AFT_BUFFER]),
    afLivingCosts: mapNumber(domain[FIELDS.AFT_LIVING_COSTS]),
    afNetCashflow: mapNumber(domain[FIELDS.AFT_NET_CASH_FLOW]),
    afMaxLoanPossible: mapNumber(domain[FIELDS.AFT_MAX_LOAN_POSSIBLE]),
  };
};

export default mapper;
